// extracted by mini-css-extract-plugin
export default {"block":"header-item_block__Zoh2b","active":"header-item_active__oLtQT"};